import { useEffect, useState } from "react";
import MapLocationList from "../MapIndex";

import CountinueOnMobileApp from "apps/Common/CountiueOnMobileApp";

const StatusViewingMap = () => {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isAndroid = /android/.test(userAgent);
    const isIOS = /iphone|ipad|ipod/.test(userAgent);
    setIsMobile(isAndroid || isIOS);
  }, []);
  return (
    <>
      <CountinueOnMobileApp desc="İlanları harita üzerinde görüntüleyebilmek için mobil uygulamamızı kullanınız" isShowDesc isShowChildren={false}>
        <MapLocationList />
      </CountinueOnMobileApp>
    </>
  );
};

export default StatusViewingMap;
